import { FileDown, Download } from "lucide-react";
import { Sign } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" });
const DECISION = { autorizado: ["Autorizou", "text-emerald-300"], recusado: ["Não autorizou", "text-rose-300"] };

// Histórico de assinaturas (registos imutáveis) + exportação conjunta num único PDF.
export default function SignHistory({ patientId, rows }) {
  if (rows === null) return <div className="text-sm text-rose-300" data-testid="sign-history-error">Não foi possível carregar o histórico de assinaturas.</div>;
  return (
    <div className="space-y-2" data-testid="sign-history">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Histórico de assinaturas</div>
        {rows.length > 0 && (
          <a href={Sign.exportUrl(patientId)} target="_blank" rel="noreferrer" data-testid="sign-export-btn"
            className="text-xs text-emerald-300 inline-flex items-center gap-1"><Download className="w-3.5 h-3.5" /> Exportar todos (PDF)</a>
        )}
      </div>
      {rows.length === 0 ? <div className="text-sm text-slate-500">Sem assinaturas registadas.</div> : (
        <div className="divide-y divide-slate-800 rounded-xl border border-slate-800">
          {rows.map((r) => {
            const dec = DECISION[r.decision];
            return (
              <div key={r.id} className="p-3 flex flex-wrap items-center gap-2 text-xs" data-testid={`sign-history-${r.id}`}>
                <div className="flex-1 min-w-[180px]">
                  <div className="text-slate-200 text-sm">{r.title}</div>
                  <div className="text-slate-500">v{r.template_version} · {fmt(r.signed_at)} · {r.mode} · {r.identity}</div>
                </div>
                {dec && <span className={`${dec[1]} shrink-0`}>{dec[0]}</span>}
                <a href={Sign.receiptUrl(r.id)} target="_blank" rel="noreferrer" data-testid={`sign-history-receipt-${r.id}`}
                  className="text-emerald-300 inline-flex items-center gap-1 shrink-0"><FileDown className="w-3.5 h-3.5" /> Comprovativo</a>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
